<template>
  <div>
    <table class="table">
      <thead>
        <tr>
          <th>Estado</th>
          <th>Usuario</th>
          <th>Fecha</th>
          <th>Comentarios</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(validation,index) in validations" :key="index">
          <td>
            <b-badge pill :variant="getStatusVariant(validation.status.description)" class="history-badge">
              {{ getStatusLabel(validation.status.description) }}
            </b-badge>
          </td>
          <td>
            <div>{{ getUserName(validation)  }}</div>
            <div>{{ getUserEmail(validation) }}</div>
          </td>
          <td>
            {{ validation.created_at || formatDate(validation.approved_at || validation.rejected_at || validation.reopened_at) }}
          </td>
          <td>
            {{ validation.comments }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { useCrisisFormStatus } from './composables/useCrisisFormStatus';

export default {
  props: {
    crisisFormData: {
      type: Object,
      default: () => {}
    },
    validations: {
      type: Array,
      default: () => []
    }
  },
  setup (props) {
    //COMPOSABLES
    const {
      formatDate,
      formatUser,
      getStatusLabel,
      getStatusVariant,
      getUserEmail,
      getUserName
    } = useCrisisFormStatus(props.crisisFormData);

    return {
      formatDate,
      formatUser,
      getStatusLabel,
      getStatusVariant,
      getUserEmail,
      getUserName
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
